import { Request } from '@/classes/Request'
import { Util } from '@/modules/util'
import type { Enrollment } from '@/types/enrollments'

export const studentEnrollments = async (studentAccountId: number) => {
  const response = await new Request().get('/ajax/student_enrollments/' + studentAccountId)
  return Util.Obj.keysToCamel(response.data.enrollments) as Enrollment[]
}
